const BASE_URL = 'https://nunt.patlush.com';

// URL / 言語別の title / description 定義
const TITLES = {
  th: {
    '/':         'Nunt | ใช้ภาพทาเลนต์สำหรับเว็บไซต์และโฆษณาในไทย',
    '/contact':  'Nunt | ปรึกษาฟรีเกี่ยวกับการใช้ภาพทาเลนต์',
    '/download': 'Nunt | ดาวน์โหลดเอกสารบริการ Nunt',
    '/privacy':  'Nunt | นโยบายความเป็นส่วนตัว',
  },
  en: {
    '/':         'Nunt | Talent Visuals for Websites and Ads in Thailand',
    '/contact':  'Nunt | Contact Us About Talent Visuals',
    '/download': 'Nunt | Download Nunt Service Materials',
    '/privacy':  'Nunt | Privacy Policy',
  },
  jp: {
    '/':         'Nunt | タレント素材で広告・Webの印象を変える',
    '/contact':  'Nunt | 無料相談・お問い合わせ',
    '/download': 'Nunt | サービス資料ダウンロード',
    '/privacy':  'Nunt | プライバシーポリシー',
  },
};

const DESCS = {
  th: 'บริการใช้ภาพทาเลนต์รายเดือนสำหรับบริษัทในไทย ใช้กับเว็บไซต์ SNS และโฆษณาได้ โดยไม่มีค่าเริ่มต้น',
  en: 'A monthly talent visual licensing service for companies in Thailand. Use ready-to-use visuals for websites, social media, and advertising.',
  jp: 'タイ法人向けのタレント素材月額サービス。Webサイト・SNS・広告に使える素材を、初期費用0 THB・月額のみで利用できます。',
};

const OGP_IMAGES = {
  th: `${BASE_URL}/ogp-th.png`,
  en: `${BASE_URL}/ogp-en.png`,
  jp: `${BASE_URL}/ogp-jp.png`,
};

const OGP_ALTS = {
  th: 'Nunt OGP image in Thai',
  en: 'Nunt OGP image in English',
  jp: 'Nunt OGP image in Japanese',
};

// document.title と meta タグ（og/twitter）を言語・ページに応じて更新する
export function setPageMeta(language, page) {
  const title = (TITLES[language] && TITLES[language][page]) || document.title;
  const description = DESCS[language] || '';
  const image = OGP_IMAGES[language] || OGP_IMAGES.th;
  const imageAlt = OGP_ALTS[language] || '';

  document.title = title;

  const setMeta = (selector, attr, value) => {
    const el = document.querySelector(selector);
    if (el) el.setAttribute(attr, value);
  };

  setMeta('meta[name="description"]',          'content', description);
  setMeta('meta[property="og:title"]',          'content', title);
  setMeta('meta[property="og:description"]',    'content', description);
  setMeta('meta[property="og:image"]',          'content', image);
  setMeta('meta[property="og:image:alt"]',      'content', imageAlt);
  setMeta('meta[name="twitter:title"]',         'content', title);
  setMeta('meta[name="twitter:description"]',   'content', description);
  setMeta('meta[name="twitter:image"]',         'content', image);
  setMeta('meta[name="twitter:card"]',          'content', 'summary_large_image');
}
